import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BookingDetailAPIElementContentModel,
  BookingDetailAPIPropertiesModel,
  ReservationDetailDto,
} from '@/services/platform/api/model';
import { cn, ModuleProperties, useLocaleStore } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { getReservation, getReservationShared } from '@/services/platform/data/booking';
import { SpinLoading } from '@/components/shared/loadings/spin';
import { BookingDetail } from '@/components/shared/booking';

export const BookingDetailAPI = (props: ModuleProperties) => {
  const content = props.content as BookingDetailAPIElementContentModel | undefined;
  const { pathname } = useLocation();
  const locale = useLocaleStore(state => state.locale);

  const bookingDetailUrl = props.context?.settings?.properties?.bookingDetail?.route?.path;

  const bookingDetailSegments = (bookingDetailUrl ?? '').split('/').filter(Boolean);
  const reservationIds = pathname.split('/').filter(Boolean).slice(bookingDetailSegments.length);
  const reservationId = reservationIds?.[0] ?? '';
  const shareCode = reservationIds?.[1] ?? undefined;

  const [reservation, setReservation] = useState<ReservationDetailDto | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (shareCode) {
      getReservationShared(reservationId, shareCode, locale)
        .then(data => setReservation(data ?? undefined))
        .catch(() => setReservation(undefined))
        .finally(() => setLoading(false));
    } else {
      getReservation(reservationId, locale)
        .then(data => setReservation(data ?? undefined))
        .catch(() => setReservation(undefined))
        .finally(() => setLoading(false));
    }
  }, [reservationId, shareCode]);

  if (!content) return null;

  const properties = content.properties as BookingDetailAPIPropertiesModel;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['step__booking-detail']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      {loading ? (
        <SpinLoading wrapperClassName="min-h-[30vh]" />
      ) : reservation ? (
        <BookingDetail reservation={reservation} properties={properties} />
      ) : null}
    </ModuleWrapper>
  );
};
